module.exports = {"list":["map1.json","map2.json","map3.json","map4.json","map5.json","map6.json"]}


//////////////////
// WEBPACK FOOTER
// ./src/game/maps/map_list.json
// module id = 8
// module chunks = 0